import PropTypes from 'prop-types';
import React from 'react';

export default function Loader(props) {
  const { message, className, style } = props;
  return (
    <div style={style.loader} className={`snapgadget-loader-container ${className}`}>
      <div className="snapgadget-loader" />
      <div className="snapgadget-loader-message">{message}</div>
    </div>
  );
}

Loader.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.shape({
    loader: PropTypes.shape({}),
  }),
};

Loader.defaultProps = {
  message: '',
  className: '',
  style: {},
};
